import { Component, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Globals } from 'app/_models/globals';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NotificationService } from 'app/_services/notification.service';

import { DisputeDetailService } from './dispute-detail.service';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { QuotationPartTypeEnum } from 'app/_models/_enums/quotationPartType.enum';
import { DisputeDetailPart } from 'app/support/_models/disputeDetail';

@Component({
    selector: 'app-dispute-detail', templateUrl: './dispute-detail.component.html', styleUrls: ['./dispute-detail.component.scss'],
    standalone: false
})
export class SupportDisputeDetailComponent {
    @ViewChild('templateDisputeDetailPart') template: TemplateRef<any>;
    disputeDetailPartList: DisputeDetailPart[] = [];
    modalRef: BsModalRef;

    orderId: number;
    vehicle: string;

    constructor(private disputeDetailService: DisputeDetailService, private ngxLoader: NgxUiLoaderService, protected notificationService: NotificationService, private modalService: BsModalService, private globals: Globals) {}

    async close(): Promise<void> {
        this.modalRef.hide()
    }

    handleFormatDisputeDetailPartList(disputeDetailPartList: DisputeDetailPart[]) {
        if (!disputeDetailPartList)
            return [];

        disputeDetailPartList.forEach((item) => {
            item.partTypeDescription = this.globals.translate(`elemento.tipo-pecas.${QuotationPartTypeEnum[item.partType].toLowerCase()}`);
            item.deliveryTypeDescription = this.globals.translate(`elemento.delivery-types.${item.deliveryType}`);
        });

        this.orderId = disputeDetailPartList[0].orderId;

        return disputeDetailPartList;

    }

    open(orderInfoId: string, vehicle: string): void {
        let options: ModalOptions = { class: 'holding-cashback-info-modal', backdrop: 'static', keyboard: false };
        this.modalRef = this.modalService.show(this.template, options);

        this.vehicle = vehicle;

        this.ngxLoader.startLoader('loader-dispute-detail');

        this.disputeDetailService.getDisputeDetails(orderInfoId).subscribe({
            next: (response: ApiResponseModel<DisputeDetailPart[]>) => {
                this.disputeDetailPartList = this.handleFormatDisputeDetailPartList(response.result);
                this.ngxLoader.stopLoader('loader-dispute-detail');

                if (this.disputeDetailPartList.length <= 0) {
                    this.close();
                    this.notificationService.showErrorToastr('support.dispute-detail.message.error.load', { translateMessage: true });
                }
            },
            error: () => {
                this.close();
                this.ngxLoader.stopLoader('loader-dispute-detail');
                this.notificationService.showErrorToastr('support.dispute-detail.message.error.load', { translateMessage: true });
            }
        })
    }
}
